import Handlebars from 'handlebars'

Handlebars.registerHelper('maps', item => {
  return new Handlebars.SafeString(
    `<div class='map' style='height:100%;width:100%;'>Deprecated, change to {{control "map"}}..</div>`
  )
})
